import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    autoSubmit: Boolean
  }

  connect() {
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("change", this.handleChange.bind(this))
    }
  }

  disconnect() {
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener("change", this.handleChange.bind(this))
    }
  }

  handleChange(event) {
    if (this.autoSubmitValue) {
      this.submitForm(event)
    }
  }

  submitForm(event) {
    const input = this.inputTarget
    if (!input || input.disabled) {
      return
    }

    const form = this.element.closest('form')
    if (form) {
      // Show loading state if needed
      form.classList.add('submitting')
      form.requestSubmit()
    }
  }
}
